export default __webpack_public_path__ + "static/plus_jeden-da940e0bba90cf29e20c51fae7f70f29.svg";